import { render, staticRenderFns } from "./index.vue?vue&type=template&id=98c115f2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=98c115f2&scoped=scoped&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=98c115f2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c115f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98c115f2')) {
      api.createRecord('98c115f2', component.options)
    } else {
      api.reload('98c115f2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=98c115f2&scoped=true&", function () {
      api.rerender('98c115f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trial/record/index.vue"
export default component.exports